"use strict";

var screenersImport = require("../../screeners");

var utils = require("../../screeners/utils");

var usefulnessScale = ["Not at all useful", "1", "2", "3", "4", "5", "6", "7", "8", "9", "Extremely useful"];
var likelihood = ["Not at all likely", "1", "2", "3", "4", "5 - Neutral", "6", "7", "8", "9", "Extremely likely"];
var ROIoptions = ["0", "1", "2", "3", "4", "5", "6", "7", "8", "9", "10"];
var sliderOptions = ["0", "1", "2", "3", "4", "5", "6", "7"];

var likelihoodFn = function likelihoodFn(n) {
  return n * 100 / (likelihood.length - 1);
};

var fnUsefulnessScaleResp = function fnUsefulnessScaleResp(n) {
  return n;
};

var difficultyOptions = ["Overloaded with work", "Current project not engaging/interesting", "Lacking resources to do job", "Uncertainty if my job is secure", "Not paid enough for the work I do", "Frustrated with a colleague/colleagues", "Family issue", "Unfair/disrespectful treatment by management", "Bullying", "Not sure what's expected of me for task/role/project", "Not recognised enough for the work I do", "Lacking friendships/peer support network at work", "Lacking opportunities to work on what I like"];
var surveyscreeners = [utils.screeners.WHO5, utils.screeners.PSS4];
var questions = screenersImport.expandscreeners([{
  prompt: "We hope you’re enjoying the program! Could you write us an anonymous testimonial that we can share with others? (we promise not to identify you)",
  type: "single",
  key: "testimonial",
  eval: function _eval(n) {
    return n;
  },
  batteryId: "survey"
}].concat(surveyscreeners, [{
  prompt: "How many days in the last week did you miss work due to mental or" + " physical health reasons (e.g. stress, fatigue, illness)?",
  extraText: "",
  options: sliderOptions,
  key: "roiAbsenteeismDays",
  eval: function _eval(n) {
    return n;
  },
  batteryId: "survey",
  type: "dayslider"
}, {
  prompt: "On how many days in the last week did you feel so impaired by stress," + " that even though you went to work, your productivity was reduced?",
  extraText: "",
  options: sliderOptions,
  key: "roiPresenteeismDays",
  eval: function _eval(n) {
    return n;
  },
  batteryId: "survey",
  type: "dayslider"
}, {
  prompt: "On how many days in the past week have you felt so stressed or" + " frustrated with work that you considered changing jobs?",
  options: sliderOptions,
  type: "dayslider",
  key: "roiTurnoverRiskDays",
  batteryId: "survey",
  eval: function _eval(n) {
    return n;
  }
}, {
  prompt: "On a scale from 0 to 10, where 0 is the worst job performance " + "anyone could have at your job and 10 is the best performance anyone " + "could have, how would you rate your overall job performance on the " + "days you worked in the past 4 weeks?",
  options: ROIoptions,
  aggregated: true,
  key: "roiPerfomance",
  type: "dayslider",
  specific: true,
  batteryId: "survey",
  eval: function _eval(n) {
    return n;
  }
}, // Company support and cohesion
{
  prompt: "In the past week, to what extent have you felt supported by " + "your company?",
  extraText: "",
  type: "slider",
  options: ["Not at all supported", "1", "2", "3", "4", "5", "6", "7", "8", "9", "Completely supported"],
  key: "companySupport",
  batteryId: "survey",
  eval: function _eval(n) {
    return 10 * n;
  }
}, {
  prompt: "In the past week, to what extent have you felt supported by " + "your manager?",
  extraText: "",
  type: "slider",
  options: ["Not at all supported", "1", "2", "3", "4", "5", "6", "7", "8", "9", "Completely supported"],
  key: "managerSupport",
  batteryId: "survey",
  eval: function _eval(n) {
    return 10 * n;
  }
}, {
  prompt: "In the past week, how united has your team been in trying to " + "reach its goals for performance?",
  extraText: "",
  type: "slider",
  options: ["Not at all united", "1", "2", "3", "4", "5", "6", "7", "8", "9", "Completely united"],
  key: "cohesion",
  batteryId: "survey",
  eval: function _eval(n) {
    return 10 * n;
  }
}, {
  prompt: "How likely are you to recommend your company to a friend as a " + "great place to work?",
  type: "slider",
  options: likelihood,
  batteryId: "survey",
  eval: function _eval(n) {
    return n * 100 / (likelihood.length - 1);
  }
}, // Sleep
{
  prompt: "Please rate the quality of your sleep over the last week.",
  extraText: "",
  type: "slider",
  options: ["Worst possible sleep", "1", "2", "3", "4", "5 - Neutral", "6", "7", "8", "9", "Best possible sleep"],
  key: "sleepQuality",
  batteryId: "survey",
  eval: function _eval(n) {
    return 10 * n;
  }
}, // Program evaluation, phrased in a way to encourage reflection
{
  prompt: "How would you rate module 1 (retraining thoughts)?",
  extraText: "",
  type: "slider",
  options: usefulnessScale,
  key: "mod1_rating",
  optional: true,
  eval: fnUsefulnessScaleResp,
  batteryId: "survey"
}, {
  prompt: "How would you rate module 2 (work-life balance)?",
  extraText: "",
  type: "slider",
  options: usefulnessScale,
  key: "mod2_rating",
  optional: true,
  eval: fnUsefulnessScaleResp,
  batteryId: "survey"
}, {
  prompt: "How would you rate module 3 (mindfulness)?",
  extraText: "",
  type: "slider",
  options: usefulnessScale,
  key: "mod3_rating",
  optional: true,
  eval: fnUsefulnessScaleResp,
  batteryId: "survey"
}, {
  prompt: "How would you rate module 4 (stress management)?",
  extraText: "",
  type: "slider",
  options: usefulnessScale,
  key: "mod4_SM_rating",
  optional: true,
  eval: fnUsefulnessScaleResp,
  batteryId: "survey"
}, {
  prompt: "How would you rate your experience with your coach?",
  extraText: "",
  type: "slider",
  options: usefulnessScale,
  batteryId: "survey"
}, {
  prompt: "How would you rate the Uprise program overall?",
  extraText: "",
  type: "slider",
  options: usefulnessScale,
  batteryId: "survey"
}, {
  prompt: "If we could change or improve anything about the program, what would it be?",
  extraText: "",
  type: "single",
  optional: true,
  key: "magicWand",
  eval: function _eval(n) {
    return n;
  },
  batteryId: "survey"
}]));

var analysis = function analysis(answers) {
  if (!answers) return null;
  var results = {};
  results.humanReadable = {};

  if (questions.length > answers.length) {
    answers.splice(26, 0, "N/A");
  }

  surveyscreeners.forEach(function (battery) {
    var batteryResults = screenersImport.extractResults(questions, answers, battery);
    var batteryHumanReadable = batteryResults.humanReadable;
    delete batteryResults.humanReadable;
    results = Object.assign(results, batteryResults);
    results.humanReadable = Object.assign(results.humanReadable, batteryHumanReadable);
    results;
  });
  questions.forEach(function (q, i) {
    if (!q.key) return;
    results[q.key] = q.eval(answers[i], q);
    results.humanReadable[q.prompt] = q.eval(answers[i], q);
  });
  return results;
};

module.exports = {
  questions: questions,
  analysis: analysis
};